export default __webpack_public_path__ + "static/media/stun2.0a4b2329.png";